export default __webpack_public_path__ + "static/media/THE_INDEPENDENT.bf710936.png";